/**
 * Datepicker
 */
$(document).on("ready", function () {
  $("body").on("focus", ".dp", function () {
    if ($(this).hasClass("hasDatepicker")) {
      return;
    }
    var $dp = $(".dp");
    $dp.datepicker();
    $(".datepicker").last().addClass("mypicker");
    $(".datepicker.mypicker")
      .hide()
      .css("top", $dp.offset().top + $dp.outerHeight() + $(window).scrollTop() + $(window).height())
      .show();
    var attr = $(this).attr("data-initdate");
    if (typeof attr !== typeof undefined && attr !== false) {
      $(this).datepicker("setDate", new Date(attr));
    }
  });
});
